module.exports = __webpack_public_path__ + "img/intrimg.3d854166.jpg";